module.exports = __webpack_public_path__ + "img/custom_bg2.397044ef.png";